import React, { FunctionComponent, memo, useContext, useEffect, useMemo } from 'react'
import { musicContext } from '@hoc/WithMusic'
import { useTranslation } from 'react-i18next'
import Autocomplete from '@components/Autocomplete/Autocomplete'
import { SurveyContext } from '@context/SurveyContext'
import { AlbumEntry } from '@models/Music'

const ArtistAutocompleteInput: FunctionComponent = () => {
  const { t } = useTranslation('Music')
  const { artists, searchArtist, selectArtist } = useContext(musicContext)
  const { currentAnswer } = useContext(SurveyContext)

  useEffect(() => {
    if (currentAnswer) {
      const { artistId: id, artist: name } = currentAnswer as AlbumEntry
      selectArtist({id , name})
    }
  }, [])

  const defaultItem = useMemo(() => {
    if (currentAnswer) {
      const { artist: label, id: value } = (currentAnswer as AlbumEntry)
      return ({
          label,
          value,
        })
    }
    }, [])

  const items = useMemo(() => artists.map(({ id: value, name: label }) => ({ value, label })), [artists])

  return (
    <Autocomplete
      placeholder={t('artist')}
      items={items}
      defaultSelectedItem={defaultItem}
      onInputChange={(input) => searchArtist(input)}
      onSelectChange={({ value: id, label: name }) => selectArtist({ id, name })}
    />
  )
}

export default memo(ArtistAutocompleteInput)
